import {
  searchContentType,
  searchLearnTimeYear,
  searchOrderType,
  searchProductType,
  searchStudyProgress,
  searchStudyWay
} from '@xt/client/dataSource'
import { EnumContentType, EnumSearchOrderType, EnumSearchProductType, EnumSearchStudyProgress, EnumSearchStudyWay } from '@xt/client/enums'

import type { Dictionary } from 'vue-router/types/router'
import type { SearchForm } from './types.d'

const defaultSearchForm = {
  contentType: '',
  learnTimeYear: '',
  orderType: EnumSearchOrderType.New,
  productType: '',
  studyProgress: '',
  studyWay: ''
} satisfies SearchForm

function matchProductType(key: string): EnumSearchProductType | string {
  switch (key) {
    case '0':
      return ''
    case '1':
      return EnumSearchProductType.Series
    case '2':
      return EnumSearchProductType.SpecialTopic
    case '3':
      return EnumSearchProductType.DayCourse
    case '4':
      return EnumSearchProductType.SelfStudy
    case '5':
      return EnumSearchProductType.StudyExhibition
    default:
      return ''
  }
}

function matchContentType(key: string): EnumContentType | string {
  switch (key) {
    case '0':
      return ''
    case '1':
      return EnumContentType.Calligraphy
    case '2':
      return EnumContentType.Painting
    case '3':
      return EnumContentType.CalligraphyAndReading
    case '4':
      return EnumContentType.AestheticEducation
    default:
      return ''
  }
}

export function matchOldVersion(query: { typeCurrent: string; directionCurrent: string }): SearchForm {
  return {
    ...defaultSearchForm,
    productType: matchProductType(query.typeCurrent),
    contentType: matchContentType(query.directionCurrent)
  }
}

export function getFieldParser(
  routerQuery: Dictionary<string | (string | null)[]>
): <T extends keyof SearchForm>(
  fieldName: T
) => T extends 'contentType'
  ? string | EnumContentType
  : T extends 'learnTimeYear'
    ? string
    : T extends 'orderType'
      ? EnumSearchOrderType
      : T extends 'productType'
        ? string | EnumSearchProductType
        : T extends 'studyProgress'
          ? string | EnumSearchStudyProgress
          : T extends 'studyWay'
            ? string | EnumSearchStudyWay
            : never {
  // @ts-ignore -- FIXME
  return (fieldName: keyof SearchForm) => {
    if (!(fieldName in routerQuery)) {
      // 兼容下特殊参数
      if (fieldName === 'orderType') return EnumSearchOrderType.New

      return ''
    }

    const fieldValue = routerQuery[fieldName]

    if (typeof fieldValue !== 'string') return ''

    switch (fieldName) {
      case 'contentType':
        return searchContentType.find(i => i.value.toString() === fieldValue)?.value || ''
      case 'learnTimeYear':
        return searchLearnTimeYear.find(i => i.value === fieldValue)?.value || ''
      case 'orderType':
        return searchOrderType.find(i => i.value.toString() === fieldValue)?.value || EnumSearchOrderType.New
      case 'productType':
        return searchProductType.find(i => i.value.toString() === fieldValue)?.value || ''
      case 'studyProgress':
        return searchStudyProgress.find(i => i.value.toString() === fieldValue)?.value || ''
      case 'studyWay':
        return searchStudyWay.find(i => i.value.toString() === fieldValue)?.value || ''
      default:
        return ''
    }
  }
}
